import React, { Fragment, Dispatch, SetStateAction } from 'react';
import { Wrapper } from "@/components";
import { TaskStatus } from '.';
import Icon from './icon';
import styles from './style.less';
import { i18n } from "@/utils";
import classnames from "classnames";

interface ErrorProps {
  /** 任务状态 */
  taskStatus: TaskStatus;
  /** 设置 zuploader组件 显影 */
  setZuploaderVisible: Dispatch<SetStateAction<boolean>>;
  /** 设置 clip组件 显影 */
  setClipVisible: Dispatch<SetStateAction<boolean>>;
  /** 重新请求人脸分割 */
  reCutFace: () => void;
  /** 关闭回调 */
  onClose: () => void;
}

const Error: React.FC<ErrorProps> = ({ taskStatus, setZuploaderVisible, setClipVisible, reCutFace, onClose }) => {

  return (
    <Wrapper className={styles.error}>
      <div
        className={styles.close}
        onClick={onClose}
      >
        <Icon type="close" color="#000" size={30} />
      </div>
      <div className={styles.errorContent}>
        <div className={styles.errorContentImage}>
          <img src={require('@/assets/new-sock/error.png')} />
        </div>
        <div className={styles.errorContentTitle}>
          {taskStatus === TaskStatus.NetworkError ?
            i18n.format('modules.global.network.error') :
            i18n.format('modules.global.ai.crop.error')
          }
        </div>
        <div className={styles.errorContentButtonList}>
          {taskStatus === TaskStatus.CropError ?
            <Fragment>
              <div
                className={classnames(styles.mainButton, styles.button)}
                onClick={() => setZuploaderVisible(true)}
              >
                <Icon type='photo' color='#f56c6c' size={20} className={styles.icon} />
                <span>{i18n.format('modules.global.replace.photo')}</span>
              </div>
              <div
                className={classnames(styles.otherButton, styles.button)}
                onClick={() => setClipVisible(true)}
              >
                <Icon type='scissors' color='#000' size={20} className={styles.icon} />
                <span>{i18n.format('modules.global.crop.myself')}</span>
              </div>
            </Fragment> :
            <Fragment>
              <div
                className={classnames(styles.mainButton, styles.button)}
                onClick={() => reCutFace()}
              >
                <Icon type='refresh' color='#f56c6c' size={20} className={styles.icon} />
                <span>{i18n.format('modules.global.try.again')}</span>
              </div>
              <div
                className={classnames(styles.otherButton, styles.button)}
                onClick={() => setClipVisible(true)}
              >
                <Icon type='scissors' color='#000' size={20} className={styles.icon} />
                <span>{i18n.format('modules.global.crop.myself')}</span>
              </div>
              <div
                className={classnames(styles.otherButton, styles.button)}
                onClick={() => setZuploaderVisible(true)}
              >
                <Icon type='photo' color='#000' size={20} className={styles.icon} />
                <span>{i18n.format('modules.global.replace.photo')}</span>
              </div>
            </Fragment>
          }
        </div>
      </div>
    </Wrapper>
  )
}

export default Error;
